import GlobalSettingsAPI from "@/api/global-settings.api"

const SHOW_INSIGHTS_SETTING = "ShowInsights"
const CACHE_DURATION_MS = 15 * 60 * 1000 // 15 minutes

const state = {
  showInsights: false,
  showInsightsLastFetched: null
}

const getters = {
  shouldShowInsights: (state) => state.showInsights,

  isInsightsCacheValid: (state) => {
    if (!state.showInsightsLastFetched) {
      return false
    }
    const now = Date.now()
    return (now - state.showInsightsLastFetched) < CACHE_DURATION_MS
  }
}

const actions = {
  async getInsightsSetting({ commit, getters }) {
    // Return cached value if still valid
    if (getters.isInsightsCacheValid) {
      return getters.shouldShowInsights
    }

    try {
      const response = await GlobalSettingsAPI.getBoolSettingValue({ settingId: SHOW_INSIGHTS_SETTING })
      const value = Boolean(response.data)
      commit('SET_SHOW_INSIGHTS', value)
      commit('SET_SHOW_INSIGHTS_LAST_FETCHED', Date.now())
      return value
    } catch {
      // If setting doesn't exist or fetch fails, default to false
      commit('SET_SHOW_INSIGHTS', false)
      commit('SET_SHOW_INSIGHTS_LAST_FETCHED', Date.now())
      return false
    }
  }
}

const mutations = {
  SET_SHOW_INSIGHTS(state, data) {
    state.showInsights = data
  },

  SET_SHOW_INSIGHTS_LAST_FETCHED(state, timestamp) {
    state.showInsightsLastFetched = timestamp
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
